module.exports = __webpack_public_path__ + "static/media/framex-group.cfdab58f.png";